/**
 * Pré-venda: metacampos custom.pre_venda_ativo + estoque da variante < 1 (a partir de 0).
 * Estoque vem do mapa Liquid (inventoryByVariantId) — o JSON de variants no storefront
 * nem sempre expõe inventory_quantity corretamente.
 */
(function () {
  function isActiveMetafield(value) {
    if (value === true || value === 1) return true;
    if (value == null || value === false) return false;
    const normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'sim';
  }

  function getVariantInventory(variant, inventoryByVariantId) {
    if (!variant) return null;
    const id = String(variant.id);
    if (inventoryByVariantId && inventoryByVariantId[id]) {
      return inventoryByVariantId[id];
    }
    if (variant.inventory_management) {
      return {
        q: Number(variant.inventory_quantity),
        managed: true,
      };
    }
    return { q: 0, managed: false };
  }

  function isVariantEligible(variant, inventoryByVariantId) {
    const inv = getVariantInventory(variant, inventoryByVariantId);
    if (!inv || !inv.managed) return false;
    return Number(inv.q) < 1;
  }

  function shouldApply(ativo, variant, inventoryByVariantId) {
    return isActiveMetafield(ativo) && isVariantEligible(variant, inventoryByVariantId);
  }

  function lineItemProperties(ativo, variant, inventoryByVariantId) {
    if (!shouldApply(ativo, variant, inventoryByVariantId)) return {};
    // Valor zero-width: checkout nativo exibe "pre-compra:" sem texto duplicado após os dois pontos.
    // O Shopify não permite omitir o formato "nome: valor" no checkout — só controlamos o valor.
    return { 'pre-compra': '\u200b' };
  }

  window.PozzePreVenda = {
    isActiveMetafield,
    getVariantInventory,
    isVariantEligible,
    shouldApply,
    lineItemProperties,
  };
})();
